import React, { useEffect, useState } from 'react';
import * as api from '../../../api'
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import Spinner from '../../../Plateforme/Atoms/Spinner';
import styled from 'styled-components';
import { exportPlanningCompanies, exportPlanningDesigners } from '../CSVExporter';
import Section from '../../../Plateforme/Atoms/Section';

const PlanningHeader = styled.div`
    overflow: scroll;
    background-color: white;
    width: calc(100vw - 90px);
    position: sticky;
    top: 0;
    z-index: 1;

    &::-webkit-scrollbar {
        display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;

    & .planningInner{
        display: grid;
        grid-template-columns: repeat(${props => props.columns}, 1fr);
        width: fit-content;
        /* overflow-x: scroll; //fix shaky scrollX */
        
        & .gridcell{
            border-collapse: collapse;
            border: 0.5px solid grey;
            padding: 5px;
            font-size: 10px;
            min-width: 150px;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;

            > span{
                cursor: pointer;

                & .complete{
                    position: absolute;
                    right: 10px;
                    top: 8px;
                }
            }
        }

        & .fixed-left {
            position: sticky;
            left: 0;
            z-index: 2;
            background-color: white;
        }

        & .grid-header {
            background-color: lightgray;
            top: 0;
            z-index: 1;
        }
    }
`

const PlanningContainer = styled.div`
    overflow: scroll;
    background-color: white;
    width: calc(100vw - 90px);

    & .planningInner{
        display: grid;
        grid-template-columns: repeat(${props => props.columns}, 1fr);
        width: fit-content;
        max-height: 80vh;
        
        & .gridcell{
            border-collapse: collapse;
            border: 0.5px solid grey;
            padding: 5px 20px;
            font-size: 10px;
            min-width: 150px;
            text-align: center;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;

            > span{
                cursor: pointer;

                & .complete{
                    position: absolute;
                    right: 10px;
                    top: 8px;
                }
            }

            & .permute-button{
                cursor: pointer;
                position: absolute;
                right: 2px;
                top: 2px;
                background-color: lightgray;
                border-radius: 50px;
                padding: 4px;
                font-size: 10px;

                &:hover{
                    opacity: 0.5;
                }

                &.active{
                    background-color: lightblue;
                }
            }
        }

        & .fixed-left {
            position: sticky;
            left: 0;
            z-index: 2;
            background-color: white;
        }

        & .grid-header {
            background-color: lightgray;
            top: 0;
            z-index: 1;
        }
    }
`

const SlotLine = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0;
`

function onlineMatch(company, slot){
    if(!company){
        console.log(company)
        console.log(slot)
    }
    return (slot.online && (company.participation.data.presentiel === "non")) || (!slot.online && (company.participation.data.presentiel === "oui")) || (company.participation.data.presentiel === "les_deux")
}

const EmptySlot = ({company,planning,allDesigners,slot,setRdv,close}) => {

    function chooseDesigner(designerParticipationId){
        if(!designerParticipationId) return;
        setRdv(company.participation._id,slot.id,designerParticipationId)
        close()
    }

    return (
        <div>
            <button onClick={close} style={{float:"right"}}>X</button>
            <h2 className='centered'>Attribuer un créneau</h2>
            <br/>
            <br/>
            <span>Créneau selectionné : {company.hsCompany?.properties?.name} - {slot.horaire}</span><br/><br/>
            <span className='thin'>Candidats dans la shortlist n'ayant pas déjà de rdv avec cette société et qui sont disponible pour ce créneau :</span><br/>
            <select onChange={(e) => chooseDesigner(e.target.value)}>
                <option value=''>Choisir un candidat</option>
                {company.shortlist?.valide.filter(designerParticipationId => !planning.data.find(rdv => rdv.designerParticipationId === designerParticipationId && (rdv.participationId === company.participation._id || rdv.slotId === slot.id)) &&  allDesigners.find(designer => designer.participation._id === designerParticipationId)).map((designerParticipationId) => {
                    let designer = allDesigners.find(designer => designer.participation._id === designerParticipationId)
                    return <option key={designer.participation._id} value={designer.participation._id}>{designer.hsCompany?.properties?.name}</option>
                })}
            </select>
        </div>
    )
}

const DesignerSlot = ({designer,planning,allCompanies,freeSlot,removeFromShortlist,close,selectedSlot}) => {

    if(selectedSlot){
        let rdv = planning.data.find(rdv => rdv.designerParticipationId === designer.participation._id && rdv.slotId === selectedSlot.id)
        var companyForThisSlot = allCompanies.find(company => company.participation._id === rdv.participationId)
    }

    let nonAttributedCompanies = allCompanies.filter(company => 
        !planning.data.find(rdv =>
            rdv.designerParticipationId === designer.participation._id && rdv.participationId === company.participation._id
        ) && company.shortlist?.valide.includes(designer.participation._id)
    )

    return (
        <div>
            <button onClick={close} style={{float:"right"}}>X</button>
            <h2 className='centered'>{designer.hsCompany?.properties?.name}</h2>
            <br/>
            <br/>
            {selectedSlot && <span>Créneau sélectionné : {companyForThisSlot?.hsCompany?.properties?.name} - {selectedSlot.horaire}</span>}<br/><br/>
            {planning.slots.map((slot) => {
                let rdv = planning.data.find(rdv => rdv.designerParticipationId === designer.participation._id && rdv.slotId === slot.id)
                let company = rdv && allCompanies.find(company => company.participation._id === rdv?.participationId)
                if(rdv && company){
                    return <div key={slot.id + designer.participation._id}>
                        <SlotLine className='thin'>{slot.horaire} : {company.hsCompany?.properties?.name} <span className='linkbutton' onClick={() => freeSlot(rdv)}>Libérer le créneau</span> {/*<span className='linkbutton' onClick={() => removeFromShortlist(company.participation._id,designer.participation._id)}>Supprimer de la shortlist</span>*/}</SlotLine>
                        {slot.online ? "Zoom" : "Table"} : {company.participation.data.numTableOULienZoom}
                    </div>
                }else{
                    return null;
                }
            })}
            <br/>
            {nonAttributedCompanies.length > 0 && <span>RDV non attribués</span>}<br/>
            <br/>
            {nonAttributedCompanies.map((company) => 
                <div key={company.participation._id}>
                        <SlotLine className='thin'>{company.hsCompany?.properties?.name} {/*<span className='linkbutton' onClick={() => removeFromShortlist(company.participation._id,designer.participation._id)}>Supprimer de la shortlist</span>*/}</SlotLine>
                </div>
            )}
        </div>
    )
}

const CompanySlot = ({company,planning,allDesigners,freeSlot,removeFromShortlist,close,selectedSlot}) => {

    if(selectedSlot){
        let rdv = planning.data.find(rdv => rdv.participationId === company.participation._id && rdv.slotId === selectedSlot.id)
        var designerForhisSlot = rdv && allDesigners.find(designer => designer.participation._id === rdv.designerParticipationId)
    }

    let nonAttributedDesigners = company.shortlist?.valide.filter(designerParticipationId => {
        let designer = allDesigners.find(designer => designer.participation._id === designerParticipationId)
        return designer && !planning.data.find(rdv => rdv.designerParticipationId === designer.participation._id && rdv.participationId === company.participation._id)
    }) || []

    return (
        <div>
            <button onClick={close} style={{float:"right"}}>X</button>
            <h2 className='centered'>{company.hsCompany?.properties?.name}</h2>
            <br/>
            <br/>
            <h3 >{company.participation.data.numTableOULienZoom}</h3>
            {selectedSlot && <span>Créneau sélectionné : {designerForhisSlot.hsCompany?.properties?.name} - {selectedSlot.horaire}</span>}<br/><br/>
            {planning.slots.map((slot) => {
                let rdv = planning.data.find(rdv => rdv.participationId === company.participation._id && rdv.slotId === slot.id)
                let designer = rdv && allDesigners.find(designer => designer.participation._id === rdv?.designerParticipationId)
                if(rdv && designer){
                    return <div key={slot.id + company.participation._id}>
                        <SlotLine className='thin'>{slot.horaire} : {designer.hsCompany?.properties?.name} <span className='linkbutton' onClick={() => freeSlot(rdv)}>Libérer le créneau</span> {/*<span className='linkbutton' onClick={() => removeFromShortlist(company.participation._id,designer.participation._id)}>Supprimer de la shortlist</span>*/}</SlotLine>
                    </div>
                }else{
                    return null;
                }
            })}
            <br/>
            {nonAttributedDesigners.length > 0 && <span>RDV non attribués</span>}<br/>
            <br/>
            {nonAttributedDesigners.map((designerParticipationId) => {
                let designer = allDesigners.find(designer => designer.participation._id === designerParticipationId)
                if(designer && !planning.data.find(rdv => rdv.designerParticipationId === designer.participation._id && rdv.participationId === company.participation._id)){
                    return <div key={designer.participation._id}>
                        <SlotLine className='thin'>{designer.hsCompany?.properties?.name} {/*<span className='linkbutton' onClick={() => removeFromShortlist(company.participation._id,designer.participation._id)}>Supprimer de la shortlist</span>*/}</SlotLine>
                    </div>
                }else{
                    return null;
                }
            })}
        </div>
    )
}

const Planning = () => {

    const [event, setEvent] = useState(null);
    const [pannel, setPannel] = useState("planning");
    const [planningView, setPlanningView] = useState("companies");
    const [allCompanies, setAllCompanies] = useState([]);
    const [allDesigners, setAllDesigners] = useState([]);
    const [planning, setPlanning] = useState(null);
    const [dataStatus, setDataStatus] = useState("saved");
    const [selectedParticipationId, setSelectedParticipationId] = useState(null);
    const [selectedSlot, setSelectedSlot] = useState(null);

    const [permuteSlot, setPermuteSlot] = useState(null);

    const [csvOuput, setCsvOutput] = useState("")

    const [windowY, setWindowY] = useState(0);
    const [CX, setCX] = useState(0);
    const [CY, setCY] = useState(0);
    const [DX, setDX] = useState(0);
    const [DY, setDY] = useState(0);

    const headerRefC = React.useRef(null);
    const planningRefC = React.useRef(null);
    const headerRefD = React.useRef(null);
    const planningRefD = React.useRef(null);

    //parse eid from url
    useEffect(() => {
        const eventIdFromParam = new URLSearchParams(window.location.search).get("eid");
        if (eventIdFromParam) {
            api.getEventById({ id: eventIdFromParam }).then((response) => {
                console.log(response.data);
                setEvent(response.data);
            }).catch((error) => {
                console.log(error);
            });
        }
    }, [])

    // get all participations
    useEffect(() => {
        if (!event) return;
        getAllParticipations()
        getPlanning()
    }, [event])
    function getAllParticipations(){
        api.getParticipatingUsersWithData({ eventId: event._id }).then((response) => {
            console.log("response.data de get all participations");
            console.log(response.data);
            setAllCompanies(response.data.filter(participation => participation.participation.type[3] === "a" && participation.participation.data?.entreprise_validee));
            setAllDesigners(response.data.filter(participation => participation.participation.type[3] === "b"));
        }).catch((error) => {
            console.log(error);
        });
    }
    function getPlanning(){
        api.GetPlanning({ eventId: event._id }).then((response) => {
            console.log("response.data de get planning");
            console.log(response.data);
            response.data.slots = response.data.slots.sort((a,b) => a.id - b.id)
            setPlanning(response.data);
            setDataStatus("saved");
        }).catch((error) => {
            console.log(error);
        });
    }

    function savePlanning(){

        for(let i = 0; i < allCompanies.length; i++){
            if(!allCompanies[i].shortlist) continue;
            api.UpsertShortlist(allCompanies[i].participation._id,allCompanies[i].shortlist).then((response) => {
                console.log(response.data);
            }).catch((error) => {
                console.log(error);
            });
        }

        api.SavePlanning({ planning: planning }).then((response) => {
            console.log("response.data de save planning");
            console.log(response.data);
            setDataStatus("saved");
        }).catch((error) => {
            console.log(error);
        });
    }

    function fillPlanning(){ // assume empty planning.data 
        let rdvs = [];
        for(let i = 0; i < allCompanies.length; i++){
            let company = allCompanies[i];
            let shortlist = company.shortlist?.valide;
            if(!shortlist) continue;
            for(let j = 0; j < planning.slots.length; j++){
                if(!onlineMatch(company,planning.slots[j])) continue; // check if slot onlineniness matche company onlineniness
                let designer = null;
                for(let k = 0; k < shortlist.length; k++){
                    let _designer = allDesigners.find(designer => designer.participation._id === shortlist[k])
                    if(_designer && !rdvs.find(rdv => rdv.slotId === planning.slots[j].id && rdv.designerParticipationId === _designer.participation._id) // check if designer is not already booked at this slot
                    && !rdvs.find(rdv => rdv.designerParticipationId === _designer.participation._id && rdv.participationId === company.participation._id)) // check if designer is not already booked at this company
                    {
                        designer = _designer;
                        break;
                    }
                }
                if(!designer) continue;
                let rdv = {
                    participationId: company.participation._id,
                    slotId: planning.slots[j].id,
                    designerParticipationId: designer.participation._id
                }
                rdvs.push(rdv);
            }
        }
        console.log(rdvs);
        // setPlanning({...planning, data: [...planning.data, ...rdvs]}) //add rdvs to planning.data
        setPlanning({...planning, data: rdvs}) //clear planning.data
        setDataStatus("changed");
    }

    function fillPlanningV2(){ // assume empty planning.data 
        let rdvs = [];
        for(let i = 0; i < allDesigners.length; i++){
            let designer = allDesigners[i];
            let reverseShortlist = [];
            for(let j = 0; j < allCompanies.length; j++){
                let company = allCompanies[j];
                if(company.shortlist?.valide?.includes(designer.participation._id)) reverseShortlist.push(company);
            }
            for(let j = 0; j < planning.slots.length; j++){
                let company = null;
                for(let k = 0; k < reverseShortlist.length; k++){
                    let _company = reverseShortlist[k];
                    if(!onlineMatch(_company,planning.slots[j])) continue; // check if slot onlineniness matche company onlineniness
                    if(!rdvs.find(rdv => rdv.slotId === planning.slots[j].id && rdv.participationId === _company.participation._id) // check if designer is not already booked at this slot
                    && !rdvs.find(rdv => rdv.participationId === _company.participation._id && rdv.designerParticipationId === designer.participation._id)) // check if designer is not already booked at this company
                    {
                        company = _company;
                        break;
                    }
                }
                if(!company) continue;
                let rdv = {
                    participationId: company.participation._id,
                    slotId: planning.slots[j].id,
                    designerParticipationId: designer.participation._id
                }
                rdvs.push(rdv);
            }
        }

        console.log(rdvs);
        // setPlanning({...planning, data: [...planning.data, ...rdvs]}) //add rdvs to planning.data
        setPlanning({...planning, data: rdvs}) //clear planning.data
        setDataStatus("changed");
    }

    function clearPlanning(){
        setPlanning({...planning, data: []})
        setDataStatus("changed");
    }

    function filterHoraireForCSV(horaire){
        return horaire.replace("7 juin /","").replace(" en ligne", "")
    }

    function generateMailingCSV(){
        let csv = "email;planning_sde_2024;planning_sde_2024_online\n";
        for(let i = 0; i < allCompanies.length; i++){
            let company = allCompanies[i];
            const rdvs = planning.data.filter(rdv => rdv.participationId === company.participation._id).sort((a,b) => a.slotId - b.slotId);
            if(rdvs.length === 0){
                continue;
            }
            csv += company.user.email + ";";
            for(let j = 0; j < rdvs.length; j++){
                let slot = planning.slots.find(slot => slot.id === rdvs[j].slotId && !slot.online);
                if(!slot) continue;
                csv += filterHoraireForCSV(slot.horaire) + " : " + allDesigners.find(designer => designer.participation._id === rdvs[j].designerParticipationId).hsCompany?.properties?.name.toUpperCase() + "<br/>";
            }
            csv += ";";
            
            //if there are some online rdvs for this company
            if(rdvs.find(rdv => planning.slots.find(slot => slot.id === rdv.slotId && slot.online))){
                const lienZoom = company.participation.data.numTableOULienZoom;
                csv += `Lien zoom : <a href="${lienZoom}">${lienZoom}</a><br/><br/>`;
            }
            for(let j = 0; j < rdvs.length; j++){
                let slot = planning.slots.find(slot => slot.id === rdvs[j].slotId && slot.online);
                if(!slot) continue;
                csv += filterHoraireForCSV(slot.horaire) + " : " + allDesigners.find(designer => designer.participation._id === rdvs[j].designerParticipationId).hsCompany?.properties?.name.toUpperCase() + `<br/>`;
            }
            csv += "\n";
        }
        for(let i = 0; i < allDesigners.length; i++){
            let designer = allDesigners[i];
            const rdvs = planning.data.filter(rdv => rdv.designerParticipationId === designer.participation._id).sort((a,b) => a.slotId - b.slotId);
            if(rdvs.length === 0){
                continue;
            }
            csv += designer.user.email + ";";
            for(let j = 0; j < rdvs.length; j++){
                let slot = planning.slots.find(slot => slot.id === rdvs[j].slotId && !slot.online);
                if(!slot) continue;
                csv += filterHoraireForCSV(slot.horaire) + " : " + allCompanies.find(company => company.participation._id === rdvs[j].participationId).hsCompany?.properties?.name.toUpperCase() + " - Table n°" + allCompanies.find(company => company.participation._id === rdvs[j].participationId).participation.data.numTableOULienZoom + "<br/>";
            }
            csv += ";";
            for(let j = 0; j < rdvs.length; j++){
                let slot = planning.slots.find(slot => slot.id === rdvs[j].slotId && slot.online);
                if(!slot) continue;
                const lienZoom = allCompanies.find(company => company.participation._id === rdvs[j].participationId).participation.data.numTableOULienZoom;
                csv += filterHoraireForCSV(slot.horaire) + " : " + allCompanies.find(company => company.participation._id === rdvs[j].participationId).hsCompany?.properties?.name.toUpperCase() + ` - lien zoom : <a href="${lienZoom}">${lienZoom}</a><br/><br/>`;
            }
            csv += "\n";
        }

        setCsvOutput(csv);
    }

    function generateMailingCSVParticipants(){
        let csv = "email;planning_sde_2024;planning_sde_2024_online\n";
        for(let i = 0; i < allCompanies.length; i++){
            let company = allCompanies[i];
            const rdvs = planning.data.filter(rdv => rdv.participationId === company.participation._id).sort((a,b) => a.slotId - b.slotId);
            if(rdvs.length === 0){
                continue;
            }
            csv += company.participation.data.email1 + ";";
            for(let j = 0; j < rdvs.length; j++){
                let slot = planning.slots.find(slot => slot.id === rdvs[j].slotId && !slot.online);
                if(!slot) continue;
                csv += filterHoraireForCSV(slot.horaire) + " : " + allDesigners.find(designer => designer.participation._id === rdvs[j].designerParticipationId).hsCompany?.properties?.name.toUpperCase() + "<br/>";
            }
            csv += ";";

            //if there are some online rdvs for this company
            if(rdvs.find(rdv => planning.slots.find(slot => slot.id === rdv.slotId && slot.online))){
                const lienZoom = company.participation.data.numTableOULienZoom;
                csv += `Lien zoom : <a href="${lienZoom}">${lienZoom}</a><br/><br/>`;
            }
            // const lienZoom = company.participation.data.numTableOULienZoom;
            // csv += `Lien zoom : <a href="${lienZoom}">${lienZoom}</a><br/><br/>`;
            for(let j = 0; j < rdvs.length; j++){
                let slot = planning.slots.find(slot => slot.id === rdvs[j].slotId && slot.online);
                if(!slot) continue;
                csv += filterHoraireForCSV(slot.horaire) + " : " + allDesigners.find(designer => designer.participation._id === rdvs[j].designerParticipationId).hsCompany?.properties?.name.toUpperCase() + `<br/>`;
            }
            csv += "\n";

            csv += company.participation.data.email2 + ";";
            for(let j = 0; j < rdvs.length; j++){
                let slot = planning.slots.find(slot => slot.id === rdvs[j].slotId && !slot.online);
                if(!slot) continue;
                csv += filterHoraireForCSV(slot.horaire) + " : " + allDesigners.find(designer => designer.participation._id === rdvs[j].designerParticipationId).hsCompany?.properties?.name.toUpperCase() + "<br/>";
            }
            csv += ";";
            //if there are some online rdvs for this company
            if(rdvs.find(rdv => planning.slots.find(slot => slot.id === rdv.slotId && slot.online))){
                const lienZoom = company.participation.data.numTableOULienZoom;
                csv += `Lien zoom : <a href="${lienZoom}">${lienZoom}</a><br/><br/>`;
            }
            // csv += `Lien zoom : <a href="${lienZoom}">${lienZoom}</a><br/><br/>`;
            for(let j = 0; j < rdvs.length; j++){
                let slot = planning.slots.find(slot => slot.id === rdvs[j].slotId && slot.online);
                if(!slot) continue;
                csv += filterHoraireForCSV(slot.horaire) + " : " + allDesigners.find(designer => designer.participation._id === rdvs[j].designerParticipationId).hsCompany?.properties?.name.toUpperCase() + `<br/>`;
            }
            csv += "\n";
        }
        for(let i = 0; i < allDesigners.length; i++){
            let designer = allDesigners[i];
            const rdvs = planning.data.filter(rdv => rdv.designerParticipationId === designer.participation._id).sort((a,b) => a.slotId - b.slotId);
            if(rdvs.length === 0){
                continue;
            }
            csv += designer.participation.data.email1 + ";";
            for(let j = 0; j < rdvs.length; j++){
                let slot = planning.slots.find(slot => slot.id === rdvs[j].slotId && !slot.online);
                if(!slot) continue;
                csv += filterHoraireForCSV(slot.horaire) + " : " + allCompanies.find(company => company.participation._id === rdvs[j].participationId).hsCompany?.properties?.name.toUpperCase() + " - Table n°" + allCompanies.find(company => company.participation._id === rdvs[j].participationId).participation.data.numTableOULienZoom + "<br/>";
            }
            csv += ";";
            for(let j = 0; j < rdvs.length; j++){
                let slot = planning.slots.find(slot => slot.id === rdvs[j].slotId && slot.online);
                if(!slot) continue;
                const lienZoom = allCompanies.find(company => company.participation._id === rdvs[j].participationId).participation.data.numTableOULienZoom;
                csv += filterHoraireForCSV(slot.horaire) + " : " + allCompanies.find(company => company.participation._id === rdvs[j].participationId).hsCompany?.properties?.name.toUpperCase() + ` - lien zoom : <a href="${lienZoom}">${lienZoom}</a><br/><br/>`;
            }
            csv += "\n";

            csv += designer.participation.data.email2 + ";";
            for(let j = 0; j < rdvs.length; j++){
                let slot = planning.slots.find(slot => slot.id === rdvs[j].slotId && !slot.online);
                if(!slot) continue;
                csv += filterHoraireForCSV(slot.horaire) + " : " + allCompanies.find(company => company.participation._id === rdvs[j].participationId).hsCompany?.properties?.name.toUpperCase() + " - Table n°" + allCompanies.find(company => company.participation._id === rdvs[j].participationId).participation.data.numTableOULienZoom + "<br/>";
            }
            csv += ";";
            for(let j = 0; j < rdvs.length; j++){
                let slot = planning.slots.find(slot => slot.id === rdvs[j].slotId && slot.online);
                if(!slot) continue;
                const lienZoom = allCompanies.find(company => company.participation._id === rdvs[j].participationId).participation.data.numTableOULienZoom;
                csv += filterHoraireForCSV(slot.horaire) + " : " + allCompanies.find(company => company.participation._id === rdvs[j].participationId).hsCompany?.properties?.name.toUpperCase() + ` - lien zoom : <a href="${lienZoom}">${lienZoom}</a><br/><br/>`;
            }
            csv += "\n";
        }

        setCsvOutput(csv);
    }

    function freeSlot(rdv){
        if (!window.confirm("Êtes-vous sûr de vouloir libérer ce créneau ?")) {
            return;
        }
        setPlanning({...planning, data: planning.data.filter(_rdv => !(_rdv.participationId === rdv.participationId && _rdv.slotId === rdv.slotId && _rdv.designerParticipationId === rdv.designerParticipationId))})
        setPannel("planning");
        setSelectedSlot(null);
        setDataStatus("changed");
    }

    function removeFromShortlist(companyParticipationId,designerParticipationId){
        if (!window.confirm("Êtes-vous sûr de vouloir retirer ce designer de la shortlist ?")) {
            return;
        }
        setPlanning({...planning, data: planning.data.filter(_rdv => !(_rdv.participationId === companyParticipationId && _rdv.designerParticipationId === designerParticipationId))})
        let company = allCompanies.find(company => company.participation._id === companyParticipationId);
        company.shortlist.valide = company.shortlist?.valide.filter(_designerParticipationId => _designerParticipationId !== designerParticipationId);
        company.shortlist.refuse.push(designerParticipationId);
        setAllCompanies([...allCompanies.filter(_company => _company.participation._id !== companyParticipationId), company]);
        setDataStatus("changed");
    }

    function setRdv(companyParticipationId,slotId,designerParticipationId){
        setPlanning({...planning, data: [...planning.data, {participationId: companyParticipationId, slotId: slotId, designerParticipationId: designerParticipationId}]})
        setDataStatus("changed");
    }

    function sendPlanning(){
        if (!window.confirm("Êtes-vous sûr de vouloir envoyer tous les plannings à tous les participants par email ?")) {
            return;
        }
        api.MailPlanning({ eventId: event._id }).then((response) => {
            console.log("response.data de send planning");
            console.log(response.data);
            window.alert("Les plannings ont été envoyés par email à tous les participants");
        }).catch((error) => {
            console.log(error);
        });
    }

    function onScrollCompanies(e){
        headerRefC.current.scrollLeft = e.target.scrollLeft;
        planningRefC.current.scrollLeft = e.target.scrollLeft;
        setCX(planningRefC.current.scrollLeft);
        setCY(planningRefC.current.scrollTop);
    }

    function onScrollDesigners(e){
        headerRefD.current.scrollLeft = e.target.scrollLeft;
        planningRefD.current.scrollLeft = e.target.scrollLeft;
        setDX(planningRefD.current.scrollLeft);
        setDY(planningRefD.current.scrollTop);
    }

    // useEffect to set scroll listener on window
    useEffect(() => {
        window.addEventListener("scroll", () => {
            if(pannel === "planning" && ((headerRefC.current && planningRefC.current) || (headerRefD.current && planningRefD.current))){
                setWindowY(window.scrollY);
            }
        });
    }, []);

    // useEffect to set scroll position on pannel change
    useEffect(() => {
        if(headerRefC.current && planningRefC.current){
            headerRefC.current.scrollLeft = CX;
            planningRefC.current.scrollTo({
                top: CY,
                left: CX,
                behavior: "instant",
              })
            window.scrollTo(0, windowY);
        }
        if(headerRefD.current && planningRefD.current){
            headerRefD.current.scrollLeft = DX;
            planningRefD.current.scrollTo({
                top: DY,
                left: DX,
                behavior: "instant",
            })
            window.scrollTo(0, windowY);
        }
    },[pannel,headerRefC.current,planningRefC.current,headerRefD.current,planningRefD.current])

    function sortByName(a,b){
        const nameA = a?.hsCompany?.properties?.name.toLowerCase();
        const nameB = b?.hsCompany?.properties?.name.toLowerCase();
        return (nameA > nameB) ? 1 : ((nameB > nameA) ? -1 : 0)
    }

    function sortByPresence(a,b){
        function presentielToValue(presentiel){
            if(presentiel === "oui"){
                return 3
            }else if(presentiel === "les_deux"){
                return 2
            }else if(presentiel === "non"){
                return 1
            }
        }
        return presentielToValue(b.participation.data.presentiel) - presentielToValue(a.participation.data.presentiel)
    }

    function getDesignerRdvCount(designer){
        // return 5
        return planning.slots.filter(slot => planning.data.find(rdv => rdv.designerParticipationId === designer.participation._id && rdv.slotId === slot.id)).length
    }

    function removePhantomRdvs(){
        if(!planning || allDesigners.length === 0 || allCompanies.length === 0){
            console.log("showPhantomRdvs : not all data ready yet");
            return;
        }
        let rdvs = planning.data;
        let phantomRdvs = [];
        for (let i = 0; i < planning.data.length; i++) {
            // if(!allDesigners.find(p => p.participation._id === planning.data[i].designerParticipationId)){
            //     // console.log("phantom rdv found, no designer found matching this id : " + planning.data[i].designerParticipationId);
            //     // console.log(planning.data[i]);
            //     phantomRdvs.push(planning.data[i]);
            // }
            if(!allCompanies.find(p => p.participation._id === planning.data[i].participationId)){
                console.log("phantom rdv found, no company found matching this id : " + planning.data[i].participationId);
                // console.log(planning.data[i]);
                // const matchingDesigner = allDesigners.find(p => p.participation._id === planning.data[i].designerParticipationId);
                // if(matchingDesigner){
                //     console.log("phantom rdv found with this user : " + matchingDesigner.hsProfile.company, matchingDesigner);
                // }else{
                //     console.log("phantom rdv found, no designer found matching this id : " + planning.data[i].designerParticipationId);
                // }
                // phantomRdvs.push(planning.data[i]);

            }

            if(!allDesigners.find(p => p.participation._id === planning.data[i].designerParticipationId)){
                console.log("phantom rdv found, no designer found matching this id : " + planning.data[i].designerParticipationId);
                console.log(planning.data[i]);
                const matchingCompany = allCompanies.find(p => p.participation._id === planning.data[i].participationId);
                if(matchingCompany){
                    console.log("phantom rdv found with this user : " + matchingCompany.hsProfile.company, matchingCompany);
                }else{
                    console.log("phantom rdv found, no company found matching this id : " + planning.data[i].participationId);
                }
                phantomRdvs.push(planning.data[i]);
            }
        }
        console.log("showPhantomRdvs : " + phantomRdvs.length + " phantom rdvs found");

        rdvs = rdvs.filter(rdv => allDesigners.find(p => p.participation._id === rdv.designerParticipationId))

        setPlanning({...planning, data: rdvs})
        setDataStatus("changed");
    }
    // showPhantomRdvs()

    function click_permute(participationId,slotId){
        if(permuteSlot && permuteSlot.participationId === participationId && permuteSlot.slotId === slotId){
            setPermuteSlot(null)
            return;
        }

        if(!permuteSlot){
            setPermuteSlot({participationId: participationId, slotId: slotId})
        }else{
            let rdv2 = planning.data.find(rdv => rdv.participationId === participationId && rdv.slotId === slotId)

            //if rdv2 is not found (empty slot), just replace rdv2 with rdv1 and make rdv1 empty
            if(!rdv2){
                setPlanning({...planning, data: planning.data.map(rdv => {
                    if(rdv.participationId === permuteSlot.participationId && rdv.slotId === permuteSlot.slotId){
                        return {...rdv, participationId: participationId, slotId: slotId}
                    }
                    return rdv
                })})
            }else{
                setPlanning({...planning, data: planning.data.map(rdv => {
                    if(rdv.participationId === permuteSlot.participationId && rdv.slotId === permuteSlot.slotId){
                        return {...rdv, participationId: participationId, slotId: slotId}
                    }
                    if(rdv.participationId === participationId && rdv.slotId === slotId){
                        return {...rdv, participationId: permuteSlot.participationId, slotId: permuteSlot.slotId}
                    }
                    return rdv
                })})
            }

            setPermuteSlot(null)
            setDataStatus("changed");
        }
    }

    function couldPermmute(participationId,slotId){
        if(!permuteSlot) return false;

        const rdv2 = planning.data.find(rdv => rdv.participationId === participationId && rdv.slotId === slotId)
        const potentialPlanningData = !rdv2 ? 
            planning.data.map(rdv => {
                if(rdv.participationId === permuteSlot.participationId && rdv.slotId === permuteSlot.slotId){
                    return {...rdv, participationId: participationId, slotId: slotId}
                }
                return rdv
            })
        :
            planning.data.map(rdv => {
                if(rdv.participationId === permuteSlot.participationId && rdv.slotId === permuteSlot.slotId){
                    return {...rdv, participationId: participationId, slotId: slotId}
                }
                if(rdv.participationId === participationId && rdv.slotId === slotId){
                    return {...rdv, participationId: permuteSlot.participationId, slotId: permuteSlot.slotId}
                }
                return rdv
            })
        ;

        return wouldBeValid(potentialPlanningData)

        function wouldBeValid(potentialPlanning){
            for(let i = 0; i < allCompanies.length; i++){
                const company = allCompanies[i];
                const rdvs = potentialPlanning.filter(rdv => rdv.participationId === company.participation._id);
                //check that no two rdvs have the same slot id or designer id
                const slotIds = rdvs.map(rdv => rdv.slotId);
                const designerIds = rdvs.map(rdv => rdv.designerParticipationId);
                if(new Set(slotIds).size !== slotIds.length || new Set(designerIds).size !== designerIds.length){
                    return false;
                }
                //check that all designerIds are in the shortlist
                const shortlist = company.shortlist?.valide;
                if(!shortlist && designerIds.length > 0){
                    return false;
                }
                if(shortlist && designerIds.some(designerId => !shortlist.includes(designerId))){
                    return false;
                }
                //check that all the slots match the company's presentiel
                if(!rdvs.every(rdv => onlineMatch(company,planning.slots.find(slot => slot.id === rdv.slotId)))){
                    return false;
                }
            }
            for(let i = 0; i < allDesigners.length; i++){
                const designer = allDesigners[i];
                const rdvs = potentialPlanning.filter(rdv => rdv.designerParticipationId === designer.participation._id);
                //check that no two rdvs have the same slot id or company id
                const slotIds = rdvs.map(rdv => rdv.slotId);
                const companyIds = rdvs.map(rdv => rdv.participationId);
                if(new Set(slotIds).size !== slotIds.length || new Set(companyIds).size !== companyIds.length){
                    return false;
                }
                // check that all the slots match the designers's presentiel // actuallylet designers be presentiel agnostic
                // if(!rdvs.every(rdv => onlineMatch(designer,planning.slots.find(slot => slot.id === rdv.slotId)))){

                //     if(slotId === "1" || slotId === "2"){
                //         // console.log("designer presentiel mismatch")
                //         // console.log(designer.participation.data.presentiel)
                //         // console.log(planning.slots.find(slot => slot.id === rdvs[0].slotId))
                //         // console.log("slot that doesnt match :")
                //         // console.log(planning.slots.find(slot => slot.id === slotId))

                //         // console.log("designer presentiel mismatch for designer id : " + designer.participation._id)
                //         // console.log("slot that doesnt match :")
                //         // console.log(rdvs.find(rdv => !onlineMatch(designer,planning.slots.find(slot => slot.id === rdv.slotId))))

                //         // console.log("designers rdvs")
                //         // console.log(rdvs)

                //         // console.log("onlineMatch(designer,planning.slots.find(slot => slot.id === rdvs[0].slotId))")
                //         // console.log(onlineMatch(designer,planning.slots.find(slot => slot.id === rdvs[0].slotId)))
                //         // console.log("planning.slots.find(slot => slot.id === rdvs[0].slotId)")
                //         // console.log(planning.slots.find(slot => slot.id === rdvs[0].slotId))
                //         // console.log("designer.participation.data.presentiel")
                //         // console.log(designer.participation.data.presentiel)

                //         // console.log("potentialPlanning")
                //         // console.log(potentialPlanning)
                //     }

                //     return false;
                // }
            }
            return true;
        }
    }

    //log planning data on change
    useEffect(() => {
        if(!planning) return;
        console.log("planning data changed :");
        console.log(planning.data);
    },[planning])

    return (
        <div>
            {/* <button onClick={() => generateMailingCSV()}>generate mailing csv</button>
            <button onClick={() => generateMailingCSVParticipants()}>generate mailing csv participants</button>
            <pre>{csvOuput}</pre> */}
            {event && planning ?
                <div>
                    <Section className='padding'>
                        <Link to="/admin/events"><button>← Retour au panneau d'administration</button></Link><br/><br/>
                        <h1>{event.title_fr}</h1>
                        <h2>{new dayjs(event.main_date).format('dddd D MMMM')}</h2>
                    </Section>
                    {pannel === "planning" && <>
                        <Section className='padding'>
                            <div className='flexinfos'>
                                {/* <button onClick={() => sendPlanning()}>Envoyer les planning</button> */}
                                {/* <button onClick={() => clearPlanning()}>Clear planning</button> */}
                                <button onClick={() => {exportPlanningCompanies(planning,allCompanies,allDesigners,"planning-société.csv")}}>Export société CSV</button>
                                <button onClick={() => {exportPlanningDesigners(planning,allCompanies,allDesigners,"planning-participants.csv")}}>Export participants CSV</button>
                                {/* <button onClick={() => fillPlanning()}>remplir tableau a partir de shortlists [keep comented !]</button> */}
                                {/* <button onClick={() => fillPlanningV2()}>remplir tableau V2</button> */}
                                {/* <button onClick={() => removePhantomRdvs()}>removePhantomRdvs</button> */}
                            </div>
                            <br/>
                            <h1 className='blacklower'>Planning </h1>
                            <select value={planningView} onChange={(e) => setPlanningView(e.target.value)}>
                                <option value="companies">Sociétés</option>
                                <option value="designers">Participants</option>
                            </select>
                        </Section>
                        {planningView === "companies" && <> {/* vue pop A */}
                            <PlanningHeader ref={headerRefC} onScroll={onScrollCompanies} columns={1 + planning.slots.length}>
                                <div className='planningInner'>
                                    <div className='gridcell grid-header fixed-left'>
                                    </div>
                                    {planning.slots.map((slot) => {
                                        return <div className='gridcell grid-header' key={slot.id}>
                                            <span className='thin'>{slot.horaire}</span>
                                        </div>
                                    })}
                                </div>
                            </PlanningHeader> 
                            <PlanningContainer ref={planningRefC} onScroll={onScrollCompanies} columns={1 + planning.slots.length}>
                                <div className='planningInner'>
                                    {allCompanies.sort(
                                        sortByName
                                    ).sort(
                                        sortByPresence
                                    ).map((participation) => {
                                        return <React.Fragment key={participation.participation._id}>
                                            <div className='gridcell fixed-left'>
                                                <span className='thin' style={{padding:"0 20px"}} onClick={() => {setSelectedParticipationId(participation.participation._id);setSelectedSlot(null);setPannel("company-slot")}}>
                                                    <strong>{participation.hsCompany?.properties?.name}</strong> {(planning.slots.every(slot => !onlineMatch(participation,slot) || planning.data.find(rdv => rdv.participationId === participation.participation._id && rdv.slotId === slot.id)) || planning.slots.filter(slot => planning.data.find(rdv => rdv.participationId === participation.participation._id && rdv.slotId === slot.id)).length >= 10) && <span className='complete'>✅</span>}<br/>
                                                    {participation.participation.data.presentiel === "oui" ? "Présentiel" : "En ligne"}<br/>
                                                    {participation.participation.data.presentiel === "oui" ? "Table" : "Zoom"} : {participation.participation.data.numTableOULienZoom}
                                                </span>
                                            </div>
                                            {planning.slots.map((slot) => {
                                                let rdv = planning.data.find(rdv => rdv.participationId === participation.participation._id && rdv.slotId === slot.id)
                                                let designer = rdv && allDesigners.find(designer => designer.participation._id === rdv?.designerParticipationId)
                                                let onclick = designer ? () => {setSelectedParticipationId(designer.participation._id);setSelectedSlot(slot);setPannel("designer-slot")} : () => {setSelectedParticipationId(participation.participation._id);setSelectedSlot(slot);onlineMatch(participation,slot) && setPannel("empty-slot")}
                                                const slotIsPermuting = permuteSlot && permuteSlot.participationId === participation.participation._id && permuteSlot.slotId === slot.id;
                                                return <div className='gridcell' key={slot.id + participation.participation._id}>
                                                    {((designer && (!permuteSlot || slotIsPermuting)) || couldPermmute(participation.participation._id, slot.id)) && <span onClick={() => click_permute(participation.participation._id, slot.id)} className={'permute-button' + (slotIsPermuting ? " active" : '')}>↹</span>}
                                                    <span onClick={onclick} className='thin'>{designer?.hsCompany?.properties?.name || (onlineMatch(participation,slot) && "---")}</span>
                                                </div>
                                            })}
                                        </React.Fragment>
                                    })}
                                </div>
                            </PlanningContainer>
                        </>}
                        {planningView === "designers" && <> {/* vue pop B */}
                            <PlanningHeader ref={headerRefD} onScroll={onScrollDesigners} columns={1 + planning.slots.length}>
                                <div className='planningInner'>
                                    <div className='gridcell grid-header fixed-left'>
                                    </div>
                                    {planning.slots.map((slot) => {
                                        return <div className='gridcell grid-header' key={slot.id}>
                                            <span className='thin'>{slot.horaire}</span>
                                        </div>
                                    })}
                                </div>
                            </PlanningHeader>
                            <PlanningContainer ref={planningRefD} onScroll={onScrollDesigners} columns={1 + planning.slots.length}>
                                <div className='planningInner'>
                                    {allDesigners.filter(designer => designer.hsCompany?.properties?.name).filter(designer => getDesignerRdvCount(designer) > 0).sort(sortByName).map((participation) => {
                                        return <React.Fragment key={participation.participation._id}>
                                            <div className='gridcell fixed-left'>
                                                <span onClick={() => {setSelectedParticipationId(participation.participation._id);setSelectedSlot(null);setPannel("designer-slot")}}>
                                                    {participation.hsCompany?.properties?.name} {planning.slots.every(slot => planning.data.find(rdv => rdv.designerParticipationId === participation.participation._id && rdv.slotId === slot.id)) && <span className='complete'>✅</span>}<br/>
                                                    <span className='thin'>{getDesignerRdvCount(participation)} rdvs</span>
                                                </span>
                                            </div>
                                            {planning.slots.map((slot) => {
                                                let rdv = planning.data.find(rdv => rdv.designerParticipationId === participation.participation._id && rdv.slotId === slot.id)
                                                let company = rdv && allCompanies.find(company => company.participation._id === rdv?.participationId)
                                                let onclick = company ? () => {setSelectedParticipationId(company.participation._id);setSelectedSlot(slot);setPannel("company-slot")} : () => {} //enpty slot for designers can't be set
                                                return <div className='gridcell' key={slot.id + participation.participation._id}>
                                                    <span onClick={onclick} className='thin'>{company?.hsCompany?.properties?.name || "---"}{company && <><br/><span className='thin'>{slot.online ? "Zoom" : "Table"} : {company?.participation?.data?.numTableOULienZoom}</span></>}</span>
                                                    
                                                </div>
                                            })}
                                        </React.Fragment>
                                    })}
                                </div>
                            </PlanningContainer>
                            {allDesigners.filter(designer => designer.hsCompany?.properties?.name).filter(designer => getDesignerRdvCount(designer) > 0).length === 0 && <p className='centered'><br/>Les participants n'apparaîtront ici qu'une fois leurs rendez-vous attribués dans la vue sociétés.</p>}
                        </>}
                        <br/>
                        {dataStatus === "saved" && <span className='thin centered'>Planning enregistré</span>}
                        {dataStatus === "changed" && <button className='centered' onClick={savePlanning}>Enregistrer</button>}
                    </>}
                    <Section className='padding'>
                        {pannel === "empty-slot" && 
                            <EmptySlot
                                company={allCompanies.find(company => company.participation._id === selectedParticipationId)}
                                planning={planning}
                                allDesigners={allDesigners}
                                slot={selectedSlot}
                                setRdv={setRdv}
                                close={() => setPannel("planning")}
                            />
                        }
                        {pannel === "designer-slot" && 
                            <DesignerSlot
                                designer={allDesigners.find(designer => designer.participation._id === selectedParticipationId)}
                                planning={planning}
                                allCompanies={allCompanies}
                                selectedSlot={selectedSlot}
                                freeSlot={freeSlot}
                                removeFromShortlist={removeFromShortlist}
                                close={() => setPannel("planning")}
                            />
                        }
                        {pannel === "company-slot" && 
                            <CompanySlot
                                company={allCompanies.find(company => company.participation._id === selectedParticipationId)}
                                planning={planning}
                                allDesigners={allDesigners}
                                selectedSlot={selectedSlot}
                                freeSlot={freeSlot}
                                removeFromShortlist={removeFromShortlist}
                                close={() => setPannel("planning")}
                            />
                        }
                    </Section>
                </div>
            :
                <Spinner/>
            }
        </div>
    );
};

export default Planning;